import { Box } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { Show, SimpleShowLayout } from "react-admin";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";
import InfoSection from "./InfoSection";
import BibliographySection from "./BibliographySection";
import AuthorsSection from "./AuthorsSection";

const ShowEmployeePublication = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const shadow = isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox;

  return (
    <Show
      title="Детайли за публикация"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          paddingY={2}
          title="Основна информация"
          textAlign="center"
        />
        <Box sx={shadow}>
          <InfoSection />
        </Box>

        <SectionTitle
          paddingY={2}
          title="Библиографски данни"
          textAlign="center"
        />
        <Box sx={shadow}>
          <BibliographySection />
        </Box>

        <SectionTitle
          paddingY={2}
          title="Автори"
          textAlign="center"
        />
        <Box sx={shadow}>
          <AuthorsSection />
        </Box>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowEmployeePublication;
